var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('loan-collateral',{staticClass:"loan-collateral-view",attrs:{"seller":_vm.seller}})}
var staticRenderFns = []

export { render, staticRenderFns }